import { Checkbox, Input, InputNumber, Radio, Select } from 'hljd'
import React from 'react'
import {
  ALL_SCENES,
  HOTEL_PLANE_VALUE,
  ONLY_INTERIOR,
  ONLY_LOCATION,
  MAN_RING_OPTION,
  WOMAN_RING_OPTION,
  MAN_RING_WITHOUT_DIAMOND,
  WOMAN_RING_WITHOUT_DIAMOND
} from '../contants'
import InputWithUnit from './InputWithUnit'
import style from './style.module.less'
const RadioGroup = Radio.Group
const CheckboxGroup = Checkbox.Group
const Option = Select.Option

const idFx = id => {
  return {
    '410': '212',
    '409': '213',
    '408': '214',
    '407': '215',
    '405': '216',
    '406': '412',
    '583': '582',
    '594': '597',
    '595': '598',
    '596': '599'
  }[id]
}
export default (
  {
    type,
    options,
    unitOptions,
    placeholder,
    fontLimit,
    key,
    disabled,
    precision,
    disabledItem,
    unit,
    unitKey
  },
  { setFieldsValue, getFieldValue },
  handleChangeDisabledItem,
  handleOptionHidden,
  handleChangeDisabledOption,
  handleChangeDataNode,
  store
) => {
  switch (type) {
    case 'radio': {
      let maxLength = options.reduce(
        (pre, { title }) => Math.max(pre, title.length),
        0
      )
      let width
      if (maxLength <= 2) {
        width = '30%'
      } else if (maxLength === 3) {
        width = '35%'
      } else if (maxLength < 7) {
        width = '50%'
      } else {
        width = '100%'
      }

      return (
        <RadioGroup
          onChange={e => {
            const value = e.target.value
            if (key === 'ring_diamond') {
              if (value === '330') {
                setTimeout(() => {
                  setFieldsValue({ ring_cut: undefined })
                  setFieldsValue({ ring_certificate: undefined })
                })
                handleChangeDisabledItem(true)
              } else {
                handleChangeDisabledItem(false)
              }
            }
            if (key === 'package_push') {
              const clothing = getFieldValue('clothing') || []
              const clothingId = idFx(value)
              setTimeout(() => {
                setFieldsValue({
                  clothing: [...clothing, clothingId].filter(
                    (el, i, pre) => pre.indexOf(el) === i
                  )
                })
              })
              handleChangeDisabledOption(clothingId)
            }
            if (key === 'man_package_push') {
              const manClothing = getFieldValue('man_clothing') || []
              const manClothingId = idFx(value)
              setTimeout(() => {
                setFieldsValue({
                  man_clothing: [...manClothing, manClothingId].filter(
                    (el, i, pre) => pre.indexOf(el) === i
                  )
                })
              })
              handleChangeDisabledOption(manClothingId)
            }
            if (key === 'plane_hotel') {
              switch (+value) {
                case HOTEL_PLANE_VALUE:
                  setTimeout(() => {
                    setFieldsValue({
                      plane_hotel_level: undefined
                    })
                  })
                  handleOptionHidden(['plane_hotel_level'], true)
                  break
                default:
                  handleOptionHidden(['plane_hotel_level'], false)
                  break
              }
            }
            if (key === 'treasure_diamond') {
              switch (+value) {
                case 877:
                  setTimeout(() => {
                    setFieldsValue({ treasure_diamond_weight: undefined })
                    setFieldsValue({ treasure_diamond_certificate: undefined })
                    setFieldsValue({ treasure_diamond_color: undefined })
                    setFieldsValue({ treasure_diamond_pure: undefined })
                    setFieldsValue({ treasure_diamond_cut: undefined })
                  })
                  handleOptionHidden(
                    [
                      'treasure_diamond_weight',
                      'treasure_diamond_certificate',
                      'treasure_diamond_color',
                      'treasure_diamond_pure',
                      'treasure_diamond_cut'
                    ],
                    true
                  )
                  return
                case 876:
                  handleOptionHidden(
                    [
                      'treasure_diamond_weight',
                      'treasure_diamond_certificate',
                      'treasure_diamond_color',
                      'treasure_diamond_pure',
                      'treasure_diamond_cut'
                    ],
                    false
                  )
                  return
              }
            }
            if (key === 'ring_diamond') {
              switch (+value) {
                case 330:
                  setTimeout(() => {
                    WOMAN_RING_WITHOUT_DIAMOND.forEach(item =>
                      setFieldsValue({ [item]: undefined })
                    )
                  })
                  handleOptionHidden(WOMAN_RING_WITHOUT_DIAMOND, true)
                  return
                case 329:
                  handleOptionHidden(WOMAN_RING_WITHOUT_DIAMOND, false)
                  return
              }
            }
            if (key === 'ring_man_diamond') {
              switch (+value) {
                case 786:
                  setTimeout(() => {
                    MAN_RING_WITHOUT_DIAMOND.forEach(item =>
                      setFieldsValue({ [item]: undefined })
                    )
                  })
                  handleOptionHidden(MAN_RING_WITHOUT_DIAMOND, true)
                  return
                case 785:
                  handleOptionHidden(MAN_RING_WITHOUT_DIAMOND, false)
                  return
              }
            }
          }}
          style={{ width: '100%' }}
        >
          {options.map(({ title, id }, index) => {
            return (
              <div style={{ display: 'inline-block', width }}>
                <Radio key={id} value={id + ''}>
                  {title}
                </Radio>
              </div>
            )
          })}
        </RadioGroup>
      )
    }

    case 'checkBox': {
      let maxLength = options.reduce(
        (pre, { title }) => Math.max(pre, title.length),
        0
      )
      let width
      if (maxLength === 1) {
        width = '25%'
      } else if (maxLength === 2) {
        width = '33.3%'
      } else if (maxLength === 3) {
        width = '33.3%'
      } else if (maxLength < 7) {
        width = '50%'
      } else {
        width = '100%'
      }
      return (
        <CheckboxGroup style={{ width: '100%' }}>
          {options.map(({ title, id }, index) => {
            return (
              <div style={{ display: 'inline-block', width }}>
                <Checkbox
                  key={id}
                  value={id + ''}
                  disabled={id == disabledItem}
                >
                  {title}
                </Checkbox>
              </div>
            )
          })}
        </CheckboxGroup>
      )
    }
    case 'select':
      return (
        <Select
          className={style.commonWidth}
          placeholder={placeholder}
          onChange={value => {
            if (key === 'scenes') {
              switch (+value) {
                case ONLY_INTERIOR:
                  setTimeout(() => {
                    setFieldsValue({ outer_scenes_num: undefined })
                    setFieldsValue({ outer_scenes_des: undefined })
                  })
                  handleOptionHidden(
                    ['outer_scenes_num', 'outer_scenes_des'],
                    true
                  )
                  handleOptionHidden(
                    ['inner_scenes_num', 'inner_scenes_des'],
                    false
                  )
                  return
                // 选择纯外景的value
                case ONLY_LOCATION:
                  setTimeout(() => {
                    setFieldsValue({ inner_scenes_num: undefined })
                    setFieldsValue({ inner_scenes_des: undefined })
                  })
                  handleOptionHidden(
                    ['inner_scenes_num', 'inner_scenes_des'],
                    true
                  )
                  handleOptionHidden(
                    ['outer_scenes_num', 'outer_scenes_des'],
                    false
                  )
                  return
                case ALL_SCENES:
                  handleOptionHidden(
                    [
                      'outer_scenes_num',
                      'outer_scenes_des',
                      'inner_scenes_num',
                      'inner_scenes_des'
                    ],
                    false
                  )
                  return
              }
            }
            if (key === 'treasure_style') {
              switch (+value) {
                case 874:
                case 352:
                case 824:
                  setTimeout(() => {
                    setFieldsValue({ treasure_size: undefined })
                    setFieldsValue({ treasure_diameter_or_length: undefined })
                  })
                  handleOptionHidden(['treasure_size'], true)
                  handleOptionHidden(['treasure_diameter_or_length'], false)
                  return
                case 351:
                case 372:
                case 378:
                  setTimeout(() => {
                    setFieldsValue({ treasure_size: undefined })
                    setFieldsValue({ treasure_diameter_or_length: undefined })
                  })
                  handleOptionHidden(['treasure_diameter_or_length'], true)
                  handleOptionHidden(['treasure_size'], false)
                  return
              }
            }
            if (key === 'ring_style') {
              if (+value == 753) {
                handleOptionHidden(MAN_RING_OPTION, true)
                handleOptionHidden(WOMAN_RING_OPTION, false)
                handleChangeDataNode('男戒', false)
                handleChangeDataNode('女戒', true)
              } else if (+value == 754) {
                handleOptionHidden(MAN_RING_OPTION, false)
                handleOptionHidden(WOMAN_RING_OPTION, true)
                handleChangeDataNode('男戒', true)
                handleChangeDataNode('女戒', false)
              } else {
                handleOptionHidden(
                  [...MAN_RING_OPTION, ...WOMAN_RING_OPTION],
                  false
                )
                handleChangeDataNode('男戒', true)
                handleChangeDataNode('女戒', true)
              }
              store.clearWomanInfo()
              store.clearManInfo()
            }
          }}
        >
          {options.map(({ title, id, disabled }, index) => (
            <Option disabled={disabled} key={id} value={id + ''}>
              {title}
            </Option>
          ))}
        </Select>
      )

    case 'inputNumber':
      return (
        <InputNumber
          placeholder={placeholder}
          min={0}
          precision={0}
          className={style.commonWidth}
        />
      )
    case 'input':
      return <Input placeholder={placeholder} className={style.commonWidth} />
    case 'precisionInput':
      // 增加单位选择，目前只给主钻/副钻增加单位选择，所以暂时只在这里加上
      return unitOptions || unit ? (
        <InputWithUnit
          placeholder={placeholder}
          step={precision}
          options={unitOptions}
          unit={unit}
          unitKey={unitKey}
          setFieldsValue={setFieldsValue}
          min={precision}
        />
      ) : (
        <InputNumber
          style={{
            width: 139
          }}
          placeholder={placeholder}
          step={precision}
          min={precision}
        />
      )
    default:
      return <Input placeholder={placeholder} className={style.commonWidth} />
  }
}
